import { useEffect } from "react";

export const RedirectPage = () => {
  useEffect(() => {
    window.location.replace('https://astriona.games')
  }, [])

  return (
    <div></div>
  );
}